<template>
  <v-snackbar
    v-model="isDisplay"
    :timeout="timeout"
    :color="backgroundColor"
    left
  >
    {{ message }}

    <template #actions>
      <v-btn :color="buttonColor" variant="text" @click="store.hide()">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts" setup>
import { useSnackBarStore } from '@/stores/snackbar'
import { storeToRefs } from 'pinia'

const store = useSnackBarStore()
const { isDisplay, message, timeout, backgroundColor, buttonColor } =
  storeToRefs(store)
</script>
